import styled from 'styled-components';

export const ButtonGrid = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 32px;
`;
